module.exports = __webpack_public_path__ + "images/80040b53c5e317a8842ee0a99be50264.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/get_started/reviews_ilustration@2x.png
// module id = 348
// module chunks = 24